import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './css/about.css';
import './css/campaign.css';
import './css/common.css';
import './css/contact.css';
import './css/download.css';
import './css/faq.css';
import './css/feature.css';
import './css/footer_info.css';
import './css/icreader.css';
import './css/introduction.css';
import './css/maintenance.css';
import './css/news.css';
import './css/price.css';
import './css/print.css';
import './css/query_appnd.css';
import './css/query_continue.css';
import './css/query_countinue_step.css';
import './css/query_first.css';
import './css/query_invalidation.css';
import './css/query_reissue_step.css';
import './css/query_reissue.css';
import './css/query.css';
import './css/sitemap.css';
import './css/sitepolicy.css';
import './css/support.css';
import './css/system.css';
import './css/toppage.css';
import { fetchmbed } from './util/fetchmbed';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/**
 * axios.get で取得した情報を、ダウンロードした html ファイルでも表示するために、
 * 事前に全ページ分取得し html 内に埋め込んでおく
 */
fetchmbed("/cms/json/faq.json")
fetchmbed("/cms/json/faq/data.json")
fetchmbed("/cms/json/news.json")
fetchmbed("/cms/json/news/data.json")
fetchmbed("/cms/json/links.json")
fetchmbed("/cms/json/about/system/data.json")
fetchmbed("/cms/json/price/campaign/data.json")

const Router = window.location.origin.indexOf('http') < 0 ? HashRouter : BrowserRouter
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
